import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from '@/lib/api/auth';
import { userKeys } from '@/lib/api/query-keys';
import { useAuthStore } from '@/store/auth-store';

export function useUserInfo() {
  const token = useAuthStore((s) => s.token);
  return useQuery({
    queryKey: userKeys.info(),
    queryFn: getUserInfo,
    enabled: Boolean(token),
    staleTime: 5 * 60_000,
  });
}

export function usePermissions(): string[] {
  return useAuthStore((s) => s.permissionList);
}

export function useHasPermission(code: string): boolean {
  return usePermissions().includes(code);
}

export function useMenuList(): string[] {
  return useAuthStore((s) => s.menuList);
}

export function useHasMenu(code: string): boolean {
  return useMenuList().includes(code);
}
